import styled from 'styled-components';
import colors from 'styles/colors';

import { NO_HEIGHT } from 'styles/commonClasses';

export const CLASSES = {
  ALIGN_TOP: 'align-top',
  ALIGN_HARD_LEFT: 'align-hard-left',
  ALIGN_RIGHT: 'align-right',
};

type ParentPositioning = {
  top: number;
  right: number;
  bottom: number;
  left: number;
  width: number;
};

export const TooltipWrapper = styled.div<{
  parentPosition: ParentPositioning;
  offset: number;
  maxHeight: number;
  width: number;
}>`
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  display: block;
  margin-top: 0;
  padding: 0;
  position: absolute;
  z-index: 9999;
  overflow-y: auto;

  ${(props) => `
    left: ${props.parentPosition.left}px;
    top: ${props.parentPosition.bottom + props.offset}px;
    min-width: ${props.width || props.parentPosition.width}px;
  `}

  ${(props) =>
    typeof props.maxHeight === 'number' &&
    `
    max-height: ${props.maxHeight}px;
  `}

  &.${CLASSES.ALIGN_RIGHT} {
    left: auto;
    ${(props) => `right: ${props.parentPosition.right}px;`}
  }

  &.${CLASSES.ALIGN_TOP} {
    top: auto;
    ${(props) => `bottom: ${props.parentPosition.top + props.offset}px;`}
  }

  &.${CLASSES.ALIGN_HARD_LEFT} {
    left: 10px;
  }

  .${NO_HEIGHT} & {
    height: 0;
  }
`;

export const ReactSelectTooltipWrapper = styled(TooltipWrapper)`
  background-color: none;
  box-shadow: none;
  overflow-y: visible;
`;
